/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import PropTypes from 'prop-types';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useQuery } from '../../hooks/useQuery';
import dayjs from 'dayjs';

import { Button, Form, Typography } from 'antd';
const { Text } = Typography;
import { ReactComponent as Cancel } from './img/cancel-icon.svg';
import { ReactComponent as Confirm } from './img/confirm-icon.svg';
import { ReactComponent as GoBackIcon } from '../../assets/go-back-icon.svg';
import { ReactComponent as EditIcon } from '../../assets/edit-icon.svg';

import OnboardingItemFabrica from './OnboardingItemFabrica/OnboardingItemFabrica';
import OnboardingCompositeItemFabrica from './OnboardingCompositeItemFabrica/OnboardingCompositeItemFabrica';
import {
  getDirectory,
  startOnboardingEdit,
  stopOnboardingEdit,
  submitOnboarding,
  updateOnboardingSubmission,
} from '../../data/store/onboarding/onboardingActions';
import OnboardingActionItemFabrica from './OnboardingActionItemFabrica/OnboardingActionItemFabrica';
import OnboardingTableFabrica from './OnboardingCompositeItemFabrica/OnboardingTableFabrica';

import { adviseList } from './data/advise-list';
import { getAdviseElement } from './data/advise-dictionary';
import './style.scss';

export const getValueObj = (type, value) => {
  let newValue = value;
  switch (type.type) {
    case 'DATE':
      newValue = dayjs(value).format('YYYY-MM-DD');
      break;
    case 'DATE_TIME':
      newValue = dayjs(value).format('YYYY-MM-DD HH:mm');
      break;
    case 'LIST_FIXED':
      return { value_text: newValue };
    default:
      break;
  }

  switch (type.submit_value_Type) {
    case 'VALUE_BOOLEAN':
      return { value_boolean: newValue };
    case 'VALUE_NUMBER':
      return { value_number: newValue };
    case 'VALUE_TEXT':
      return { value_text: newValue };
    case 'VALUE_BINARY_FILE':
      return {
        value_binary_file: {
          data: newValue,
          mime_type: 'application/pdf',
          name: 'document.pdf',
        },
      };
    default:
      return {};
  }
};

const OnboardingCategory = ({
  item,
  wayPoint,
  onboardingPoints,
  getNameByCode,
  validateCategory,
}) => {
  console.log('🚀 ~ OnboardingCategory ~ validateCategory:', validateCategory);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const { search, pathname } = useLocation();
  const { onboardingId } = useParams();
  const contentRef = useRef(null);
  const query = useQuery(search);

  const userId = query.get('account-id');
  const code = query.get('code');
  const category = query.get('category');
  const subCategory = query.get('sub-category');

  const getPath = useMemo(() => {
    const path = adviseList.find((i) => i.code === code)?.path;
    return path;
  }, [code]);

  useEffect(() => {
    dispatch(getDirectory('country'));
    return () => {
      form.resetFields();
      dispatch({type: 'CLEAR_ONBOARDING_SUBMISSION'});
      setData(null);
    };
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [category, subCategory]);

  const { onboardingById } = useSelector( (state) => state.onboardingReducer);

  const isSubmiteRady = useMemo(() => {
    const keys = Object.keys(validateCategory);
    let result = [];
    keys.forEach( key => {
      if(Array.isArray(validateCategory[key])) {
        validateCategory[key].forEach( item => {
          result.push(item.mandatory === item.filledMandatory);
        });
      } else {
        result.push(validateCategory[key].mandatory === validateCategory[key].filledMandatory);
      }
    });
    return result.every(item => item);
  }, [validateCategory]);

  const [data, setData] = useState(null);

  const datePickerValueFromSubmission = (valueText) => {
    if (valueText == null || valueText === '') {
      return undefined;
    }
    const parsed = dayjs(valueText);
    return parsed.isValid() ? parsed : undefined;
  };

  const subCategoryItem = useMemo(() => {
    const data = item?.subCategory?.find((i) => i.id === subCategory);
    return data ?? item;
  }, [subCategory, item]);

  const handleSaveOnbording = () => {
    form.submit();
  };

  useEffect(() => {
    let data = {};
    if(onboardingById) {
      const {attachment, status, sent_document_external_id, sent_document_signed,...rest} = onboardingById;
      data = {...rest};
    }
    form.setFieldsValue(data);
  }, [data, subCategoryItem, onboardingById, category, subCategory, form, onboardingId]);

  const nextCategory = useMemo(() => {
    const index = wayPoint.indexOf(subCategory ?? category);
    if (index + 1 >= wayPoint.length) return null;
    const nestId = wayPoint[index + 1];
    const isCategory =
      onboardingPoints.find((i) => i.id === nestId)
        ?.parent_form_element_group_id === null;
    const categoryIdBiSub = (id) => {
      const category = onboardingPoints.find((i) =>
        i.subCategory.find((j) => j.id === id),
      )?.id;
      return category;
    };
    if (isCategory) {
      return { category: nestId, subCategory: null };
    } else {
      return { category: categoryIdBiSub(nestId), subCategory: nestId };
    }
  }, [subCategory, wayPoint, category]);

  const goToNextCategory = () => {
    const newQuery = new URLSearchParams(search);
    newQuery.set('category', nextCategory.category);
    nextCategory.subCategory
      ? newQuery.set('sub-category', nextCategory.subCategory)
      : newQuery.delete('sub-category');
    history.replace({
      pathname,
      search: `?${newQuery.toString()}`,
    });
  };

  const onSubmit = (data) => {
    const addData = {...data, external_reference: userId};
    dispatch(updateOnboardingSubmission({
      path: getPath,
      id: onboardingId,
      data: addData,
    }));
    nextCategory && goToNextCategory();
  };

  const handleSubmitOnbording = () => {
    if (onboardingById?.id) {
      dispatch(submitOnboarding({path: getPath, id: onboardingById?.id}));
      history.replace(`/accounts/${userId}/inform/onboarding`);
    }
  };

  const notEditableList = ['SUBMITTED', 'CANCELED', 'COMPLETED'];

  const notEditable = useMemo(() => {
    return onboardingById?.status?.type !== 'DRAFT';
  }, [onboardingById]);

  const isSubmitAllowed = (status) => {
    return ['AVAILABLE', 'EDITING'].includes(status);
  };

  const isShowDependence = useCallback(
    (id, value) => {
      if (value === undefined || value === null) return true;
      const observation = onboardingById?.form_input_element_submissions
        ?.filter((i) => i.form_input_element_id === id)
        .map((i) => i.value_text);

      if (observation.length > 0) {
        const result = observation?.includes(value);
        return result;
      } else {
        return false;
      }
    },
    [onboardingById?.form_input_element_submissions],
  );

  const handleBack = () => {
    history.replace(`/accounts/${userId}/inform/onboarding`);
  };

  const fillFormData = useMemo(() => {
    const data = item?.form_element?.map((i) => {
      const codeItem = getAdviseElement(i.code) ?? {};
      return {
        ...i,
        name: getNameByCode(i.code),
        ...codeItem,
      };
    });
    return data;
  }, [item, getNameByCode]);

  return (
    <div className="onboarding-right-wrapper">
      <header className="onboarding-right-header">
        <Button
          icon={<GoBackIcon />}
          iconPosition="end"
          className={'add-btn-whith-icon'}
          onClick={handleBack}
        >
          <Text>{t('GO_BACK')}</Text>
        </Button>
      {onboardingById?.status?.type === 'DRAFT' &&
        <Button
          disabled={!isSubmiteRady}
          icon={<Cancel />}
          iconPosition="end"
          className={'add-btn-whith-icon'}
          onClick={handleSubmitOnbording}
        >
          <Text>{t('SUBMIT')}</Text>
        </Button>}
      </header>
      <div className="onbording-card card-right">
        <div
          ref={contentRef}
          style={{ overflowY: 'auto' }}
          className="onbording-content-wrapper"
        >
          <h2 className="onbording-card-header category-title">
            {getNameByCode(item?.code)}
          </h2>
          <h3 className="category-sub-title">
            {getNameByCode(subCategoryItem?.code)}
          </h3>
          <div className="onboarding-item-fabrica-wrapper">
            <Form
              form={form}
              onFinish={onSubmit}
              disabled={notEditable}
              name="onboarding-form"
              layout="vertical"
              className="instrument-form model-settings"
              autoComplete="off"
              validateTrigger="onBlur"
            >
              {onboardingById &&
                fillFormData?.map(
                  (i) =>
                    isShowDependence(
                      i?.dependence?.input_id,
                      i?.dependence?.value,
                    ) && (
                      <div
                        key={i.id}
                        style={{
                          marginBottom: '24px',
                          width: i?.size
                            ? i?.size
                            : '100%',
                        }}
                      >
                        {i?.item_type === 'simple' && (
                          <OnboardingItemFabrica
                            formItem={i}
                            form={form}
                            getNameByCode={getNameByCode}
                            getPath={getPath}
                            notEditable={notEditable}
                          />
                        )}
                        {i?.item_type === 'composite' && i?.display === 'table' && 
                          <OnboardingTableFabrica formItem={i} />}
                        {i?.item_type === 'composite' && i?.display !== 'table' &&
                          <OnboardingCompositeItemFabrica formItem={i} />
                        }
                        {Object.hasOwn(i, 'form_action_element') && (
                          <OnboardingActionItemFabrica
                            formItem={i}
                            onboardingId={onboardingById?.id}
                          />
                        )}
                      </div>
                    ),
                )}
            </Form>
          </div>
        </div>
        <Button
          disabled={onboardingById?.status?.type !== 'DRAFT'}
          icon={<Confirm />}
          iconPosition="end"
          type="text"
          className="start-onbording-btn"
          onClick={handleSaveOnbording}
        >
          {t('CONFIRM')}
        </Button>
      </div>
    </div>
  );
};

export default OnboardingCategory;

OnboardingCategory.propTypes = {
  item: PropTypes.object,
  wayPoint: PropTypes.array,
  onboardingPoints: PropTypes.array,
  getNameByCode: PropTypes.func,
  validateCategory: PropTypes.object,
};
